function handleSidebarLink(e) {
  const clickedLink = e.target.closest('.gdc-accordion-sidebar__sidebar-link')
  const sidebarLinks = document.querySelectorAll('.gdc-accordion-sidebar__sidebar-link')

  sidebarLinks.forEach(link => {
    if (link != e.target) {
      link.classList.remove('gdc-sidebar-link-active')
    }
  })
  
  clickedLink.classList.add('gdc-sidebar-link-active')

}

function handleSidebarActiveLinkOnScroll() {
  const _s = {
    faqSectionAnchors: document.querySelectorAll('.gdc-accordion-sidebar__group-anchor'),
    faqSidebarLinks: document.querySelectorAll('.gdc-accordion-sidebar__sidebar-link'),
    accordionSection: document.querySelector('.gdc-accordion-sidebar__section')
  }

  function activateLink(elemId) {
    _s.faqSidebarLinks.forEach(link => {
      let anchor = link.dataset.anchor 

      link.classList.remove('gdc-sidebar-link-active')
      
      if (anchor === elemId) {
        link.classList.add('gdc-sidebar-link-active')
      }
    })
  }
  
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const elemId = entry.target.id

      if (entry.isIntersecting) {
        activateLink(elemId)
      }

    })
  }, { threshold: 1, rootMargin: "-250px" })
    
  _s.faqSectionAnchors.forEach(title => {
    observer.observe(title)
  })
  
}

function handleMobileAccordionSidebar(e) {
  const parent = e.target.closest('.gdc-accordion-sidebar__sidebar-wrapper')
  const sidebar = parent.querySelector('.gdc-accordion-sidebar__sidebar')
  const iconClose = parent.querySelector('.gdc-icon-close')
  const iconOpen = parent.querySelector('.gdc-icon-open')

  sidebar.classList.toggle('active-sidebar')
  iconClose.classList.toggle('hide-icon')
  iconOpen.classList.toggle('hide-icon')
}

window.addEventListener('DOMContentLoaded', handleSidebarActiveLinkOnScroll)
